import { useCallback } from 'react'

import Logo from '~/assets/img/gpaLogo.png'
import { PersonalTrainerSignUpForm } from '~/forms/PersonalTrainerSignUpForm'
import { authenticatePersonalTrainer } from '~/modules/authentication/services'
import { PersonalTrainerSingUpDTO } from '~/modules/personalTrainer/schema'
import { signUpPersonalTrainer } from '~/modules/personalTrainer/services'

export function PersonalTrainerSignUp() {
  const handleFormSubmit = useCallback(
    async (payload: PersonalTrainerSingUpDTO) => {
      const data = await signUpPersonalTrainer(payload)
      if (data) {
        await authenticatePersonalTrainer({
          documentNumber: data.documentNumber,
          password: payload.password!,
        })
      }
    },
    [],
  )

  return (
    <div className='bg-gpa-blue-50 flex flex-col py-8 place-content-center min-h-screen'>
      <div className='flex flex-col justify-center items-center gap-6 m-auto'>
        <img src={Logo} alt='GPA' width={140} />
        <div className='flex flex-col gap-4 bg-white p-6 rounded-lg shadow-lg'>
          <h2 className='text-2xl text-center mb-4'>
            Faça seu cadastro &bull; Personal Trainer
          </h2>
          <PersonalTrainerSignUpForm onSubmit={handleFormSubmit} />
        </div>
      </div>
    </div>
  )
}
